<template>
	<v-card class="app-section" flat tile>
		<v-card-title :class="titleClasses" v-if="$slots.title">
			<slot name="title"></slot>
		</v-card-title>
		<v-card-text>
			<slot></slot>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		titleColor: String,
	},
	computed: {
		titleClasses() {
			const classes = []
			if (this.titleColor) {
				classes.push(this.titleColor)
			}
			return classes
		},
	},
}
</script>


<style scoped>
	.app-section /deep/ div {
		color: #333;
	}
</style>
